/* eslint-disable import/prefer-default-export */

// Queries

export const flexFieldsByPaidolId = /* GraphQL */ `
  query FlexFieldsByPaidolId(
    $paidolId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    flexFieldsByPaidolId(
      paidolId: $paidolId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        paidolId
        name
        alias
        order
        source
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const flexFieldValuesByFlexFieldId = /* GraphQL */ `
  query FlexFieldValuesByFlexFieldId(
    $flexFieldId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    flexFieldValuesByFlexFieldId(
      flexFieldId: $flexFieldId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        paidolId
        flexFieldId
        externalId
        value
        status
        flexFieldUploadId
        createdAt
      }
      nextToken
    }
  }
`;

export const flexFieldUploadsByPaidolId = /* GraphQL */ `
  query FlexFieldUploadsByPaidolId(
    $paidolId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    flexFieldUploadsByPaidolId(
      paidolId: $paidolId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        paidolId
        flexFieldId
        storageFileKey
        fileName
        status
        errors
        rowCount
        createdBy
        createdAt
      }
      nextToken
    }
  }
`;

// Mutations

export const createFlexField = /* GraphQL */ `
  mutation CreateFlexField($input: CreateFlexFieldInput!) {
    createFlexField(input: $input) {
      id
      paidolId
      name
      alias
      order
      source
      createdBy
      createdAt
      updatedAt
    }
  }
`;

export const deleteFlexField = /* GraphQL */ `
  mutation DeleteFlexField($input: DeleteFlexFieldInput!) {
    deleteFlexField(input: $input) {
      id
    }
  }
`;

export const createFlexFieldUpload = /* GraphQL */ `
  mutation CreateFlexFieldUpload($input: CreateFlexFieldUploadInput!) {
    createFlexFieldUpload(input: $input) {
      id
      paidolId
      flexFieldId
      fileName
      status
      createdBy
      createdAt
    }
  }
`;
